import {openPanelInModal} from '@Components/modal-container/modal-container-reducer';
import {MODALS_IDS} from '@Components/modal-container';
import type {PosterEditorTranscriptOutlinePanelProps} from '@Panels/poster-editor-transcript-outline-panel/poster-editor-transcript-outline-panel.types';

export const PANEL_ID = 'poster-editor-transcript-outline-panel';

export const openPosterEditorTranscriptOutlineModal = (props?: PosterEditorTranscriptOutlinePanelProps): void => {
  window.PMW.redux.store.dispatch(
    openPanelInModal({
      modalId: MODALS_IDS.POSTER_EDITOR_TRANSCRIPT_OUTLINE_MODAL,
      panelProps: {
        panelId: PANEL_ID,
        ...props,
      },
    })
  );
};
